import React from 'react';

import BarraSubAbas from '../../../../components/BarraSubAbas';
import ContainerWorkspace from '../../../../components/ContainerConteudo';
import subAbas from '../subabas';

const HomeNumero: React.FC = () => {
  return (
    <>
      <BarraSubAbas subAbas={subAbas} />
      <ContainerWorkspace>
        <b>Números</b>
      </ContainerWorkspace>
    </>
  );
};

export default HomeNumero;
